import { render, staticRenderFns } from "./ListMatterContact.vue?vue&type=template&id=1e1a1510"
import script from "./ListMatterContact.vue?vue&type=script&lang=js"
export * from "./ListMatterContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports